import React from "react"
import { Tractor, Edit } from "../../images/"
import { useState, useEffect } from "react"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../components/BottomBar/bottombar"
import AlertIcon from "components/AlertIcon/alertIcon"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory, useLocation } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import { toast } from "react-toastify"
import { Trans, useTranslation } from "react-i18next"
import i18next from "i18next"

const KioskTractor = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [disabledProceed, setdisabledProceed] = useState(true)
  const [disabledPhone, setdisabledPhone] = useState(false)
  const [TractorNumber, setTractorNumber] = useState("")
  const [invalidTractorNumber, setinvalidTractorNumber] = useState(false)
  const [visitId, setVisitId] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isReadonly, setIsReadonly] = useState(false)
  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const visitReducer = useSelector((state: RootState) => state.visitReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    setTractorNumber(assetReducer.asset.tractor)
    setVisitId(visitReducer.visit.id)
    if (assetReducer.asset.tractor.length > 0) {
      setIsReadonly(true)
    }
  }, [])
  const handlePaste = (limit: number) => {
    let truncatTractorNumber = TractorNumber.substring(0, limit)
    setTractorNumber(truncatTractorNumber)
  }
  useEffect(() => {
    if (TractorNumber.trim().length > 0) {
      setdisabledProceed(false)
    } else {
      setdisabledProceed(true)
    }
  }, [TractorNumber])

  const setAssetsDetails = () => {
    let asset = {
      ...assetReducer.asset,
      tractor: TractorNumber
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    http
      .post(
        `${apiEndPoints.activities}${visitId}/activities`,
        {
          type: "tractor-details-submitted",
          mode: "kiosk",
          details: {
            assetDetails: {
              tractor: {
                number: TractorNumber
              }
            }
          }
        },
        {}
      )
      .then(res => {
        history.push("/kiosk-trailer-info")
      })
      .catch(err => toast.error(err.response.data.error))
  }

  const onClickEdit = () => {
    setIsEdit(true)
    setIsReadonly(false)
  }
  const trans = (key: string) => {
    return i18next.t(key) || ""
  }
  return (
    <>
      <div className="container">
        <div className="header-text">
          {isReadonly ? (
            <>
              <Trans
                i18nKey="validate_your_truck_number"
                components={{ newLine: <br /> }}
              />{" "}
            </>
          ) : (
            ""
          )}

          {!isReadonly ? (
            <>
              {" "}
              <Trans
                i18nKey="enter_your_truck_number"
                components={{ newLine: <br /> }}
              />
            </>
          ) : (
            ""
          )}
        </div>
        <div style={{ display: "flex", width: "65%" }}>
          <div style={{ width: "100%" }}>
            <div
              className={` driver-input driver-input-USDOT-font ${
                invalidTractorNumber ? "error-label" : ""
              }`}
            >
              <Input
                autoFocus={true}
                className={`${invalidTractorNumber ? "error-label" : ""}`}
                placeholder={trans("enter_your_truck_here")}
                label={trans("truck_number")}
                defaultValue={TractorNumber}
                maxLength={20}
                readOnly={isReadonly}
                disabled={disabledPhone}
                hideLabel={false}
                invalid={invalidTractorNumber}
                onChange={event => setTractorNumber(event.target.value)}
                onPaste={e => handlePaste(20)}
                errorLabel={
                  invalidTractorNumber ? trans("tractor_not_valid") : ""
                }
                icon={
                  invalidTractorNumber ? (
                    <AlertIcon className="elemental-Input-icon--invalid" />
                  ) : TractorNumber && !isEdit && isReadonly ? (
                    <img src={Edit} className="edit" onClick={onClickEdit} />
                  ) : (
                    <></>
                  )
                }
              />
            </div>
          </div>
          <div style={{ margin: "auto" }}>
            <img src={Tractor} />
          </div>
        </div>
      </div>
      <BottomBar
        disabled={disabledProceed}
        onClick={() => setAssetsDetails()}
        text={t(isReadonly ? "looks_good_continue" : "continue")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}

export default KioskTractor
